import { object, string, SchemaOf } from 'yup';

import { TaskInvitation } from '@graphql/generated';

export const taskInviteEmailSchema: SchemaOf<
  Pick<TaskInvitation, 'email'> & {
    role: string;
  }
> = object({
  email: string().defined(),
  role: string().nullable(),
});

// TODO: research yup for passing in a generic role for each schema use case
// possibly create a new schema for each role enum
